import { render, staticRenderFns } from "./NotificacionesPush.vue?vue&type=template&id=2967d99e"
import script from "./NotificacionesPush.vue?vue&type=script&lang=js"
export * from "./NotificacionesPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports